/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Registry API
 * Module-scoped contract for the `registry` module in `backend-next`. This covers the current phase-0 master-data slice for clubs, teams, people, player profiles, team memberships, and current user-managed views. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamResponse
 */
export interface TeamResponse {
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    sportId: string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    sportCode: string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    clubId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    clubName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    status: string;
}

/**
 * Check if a given object implements the TeamResponse interface.
 */
export function instanceOfTeamResponse(value: object): value is TeamResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('sportId' in value) || value['sportId'] === undefined) return false;
    if (!('sportCode' in value) || value['sportCode'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function TeamResponseFromJSON(json: any): TeamResponse {
    return TeamResponseFromJSONTyped(json, false);
}

export function TeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'sportId': json['sportId'],
        'sportCode': json['sportCode'],
        'clubId': json['clubId'] == null ? undefined : json['clubId'],
        'clubName': json['clubName'] == null ? undefined : json['clubName'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
        'status': json['status'],
    };
}

export function TeamResponseToJSON(json: any): TeamResponse {
    return TeamResponseToJSONTyped(json, false);
}

export function TeamResponseToJSONTyped(value?: TeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'shortName': value['shortName'],
        'sportId': value['sportId'],
        'sportCode': value['sportCode'],
        'clubId': value['clubId'],
        'clubName': value['clubName'],
        'countryCode': value['countryCode'],
        'state': value['state'],
        'city': value['city'],
        'status': value['status'],
    };
}

